function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import { TableListContext } from "./TableList.utils";
/**
 * Provides configuration to a non-grid table.
 * Implemented as a class component to promote stability even when callback props change their reference.
 */
export class TableListProvider extends Component {
  constructor() {
    var _this$props$variant;
    super(...arguments);
    _defineProperty(this, "toggleExpandedRow", rowId => {
      const {
        expandedRows
      } = this.state.value;
      const rowExpanded = !expandedRows[rowId];
      if (this.props.singleExpandOnly && rowExpanded) {
        Object.keys(expandedRows).forEach(key => {
          expandedRows[key] = false;
        });
      }
      this.setState({
        value: _objectSpread(_objectSpread({}, this.state.value), {}, {
          expandedRows: _objectSpread(_objectSpread({}, expandedRows), {}, {
            [rowId]: rowExpanded
          })
        })
      });
    });
    _defineProperty(this, "setSort", newSort => {
      const {
        onSortChange
      } = this.props;
      const {
        sort
      } = this.state.value;
      const dataChanged = (sort === null || sort === void 0 ? void 0 : sort.colIndex) !== (newSort === null || newSort === void 0 ? void 0 : newSort.colIndex) || (sort === null || sort === void 0 ? void 0 : sort.sort) !== (newSort === null || newSort === void 0 ? void 0 : newSort.sort);
      if (dataChanged) {
        onSortChange && onSortChange(newSort);
        this.setState({
          value: _objectSpread(_objectSpread({}, this.state.value), {}, {
            sort: newSort
          })
        });
      }
    });
    _defineProperty(this, "setSelectedRows", changes => {
      const {
        onSelectionChange
      } = this.props;
      const {
        selectedRows
      } = this.state.value;
      let dataChanged = false;
      Object.keys(changes).forEach(id => {
        const isSelected = changes[id];
        if (selectedRows[id] !== isSelected) {
          selectedRows[id] = isSelected;
          dataChanged = true;
        }
      });
      if (dataChanged) {
        const newSelectedRows = _objectSpread({}, selectedRows);
        onSelectionChange && onSelectionChange(newSelectedRows, changes);
        this.setState({
          value: _objectSpread(_objectSpread({}, this.state.value), {}, {
            selectedRows: newSelectedRows
          })
        });
      }
    });
    _defineProperty(this, "state", {
      value: {
        columnDefs: this.props.columnDefs,
        expandableRows: this.props.expandableRows,
        expandedRows: {},
        enableRowSelection: this.props.enableRowSelection,
        selectedRows: this.props.selectedRows || {},
        sort: this.props.sort,
        variant: (_this$props$variant = this.props.variant) !== null && _this$props$variant !== void 0 ? _this$props$variant : 'default',
        hasActionColumn: this.props.hasActionColumn,
        numRows: this.props.numRows,
        numSelectedRows: this.props.numSelectedRows,
        onToggleAllSelection: this.props.onToggleAllSelection,
        toggleExpandedRow: this.toggleExpandedRow,
        setSelectedRows: this.setSelectedRows,
        setSort: this.setSort
      }
    });
  }
  componentDidUpdate(prevProps) {
    const {
      sort,
      selectedRows,
      columnDefs,
      numRows,
      numSelectedRows,
      onToggleAllSelection
    } = this.props;

    // Makes sure the internal state reflects the provided sort prop.
    if (sort !== prevProps.sort) {
      this.setState(s => ({
        value: _objectSpread(_objectSpread({}, s.value), {}, {
          sort
        })
      }));
    }

    // Makes sure the internal state reflects the provided selectedRows prop.
    if (selectedRows !== prevProps.selectedRows && selectedRows) {
      this.setState(s => ({
        value: _objectSpread(_objectSpread({}, s.value), {}, {
          selectedRows
        })
      }));
    }
    if (columnDefs !== prevProps.columnDefs) {
      this.setState(s => ({
        value: _objectSpread(_objectSpread({}, s.value), {}, {
          columnDefs
        })
      }));
    }
    if (numRows !== prevProps.numRows) {
      this.setState(s => ({
        value: _objectSpread(_objectSpread({}, s.value), {}, {
          numRows
        })
      }));
    }
    if (numSelectedRows !== prevProps.numSelectedRows) {
      this.setState(s => ({
        value: _objectSpread(_objectSpread({}, s.value), {}, {
          numSelectedRows
        })
      }));
    }
    if (onToggleAllSelection !== prevProps.onToggleAllSelection) {
      this.setState(s => ({
        value: _objectSpread(_objectSpread({}, s.value), {}, {
          onToggleAllSelection
        })
      }));
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(TableListContext.Provider, {
      value: this.state.value
    }, this.props.children);
  }
}